import React from "react";

export const convertToBold = (text: string) => {
  const splitted = text.split("<b>");
  const atTheBeginning = text.indexOf("<b>") === 0;

  return text.indexOf("<b>") !== -1 ? (
    splitted.map((segment, idx) => (
      <span
        style={{
          fontWeight: atTheBeginning ? ((idx + 1) % 2 === 0 ? 400 : 800) : (idx + 1) % 2 === 0 ? 800 : 400,
        }}
      >
        {segment}
      </span>
    ))
  ) : (
    <span>{text}</span>
  );
};
